export type StoreAppConfig = {
  features: {
    transactions: {
      supported_cexs: string[];
    };
    // TODO move this entry to flag management tool
    activity_to_portfolio: {
      supported_cexs: string[];
    };
    in_app_tutorials: {
      supported_cexs: string[];
    };
  };
  jobs: {
    [key: string]: {
      supported_cexs?: string[];
      method: string;
      update_interval: number;
    };
  };
  cooldowns: {
    fetch_transactions_manually: number;
  };
  supported_languages: string[];
  // Define constants for te fetch cycle to settle a transaction status
  refresh_status: {
    interval: number; // how ofter do we check the status of a transaction (milliseconds)
    max_time: number; // how long do we wait for a transaction to settle (milliseconds)
  };
  track_metrics: {
    identify: boolean;
    track: boolean;
    page: boolean;
    track_send_address: boolean;
  };
  enable_sentry: boolean;
  oauth: {
    send_tutorial: {
      supported_cexs: string[];
    };
  };
  // TODO move this entry to flag management tool
  hidden_features: {
    edit_assets: boolean;
    hide_balance_below: boolean;
  };
  // TODO move this entry to flag management tool
  uninstall_url_fallback?: string;
};
